import { action } from 'typesafe-actions';
import {
  AdvertisementRadioResult,
  IAdvertisementRadioActionTypes,
} from './Types';

export const getAdvertisementRadio = (id: number) =>
  action(IAdvertisementRadioActionTypes.GET_AD_RADIO, id);
export const getAdvertisementRadioSuccess = (
  result: AdvertisementRadioResult
) => action(IAdvertisementRadioActionTypes.GET_AD_RADIO_SUCCESS, result);
export const getAdvertisementRadioFailure = (err: string) =>
  action(IAdvertisementRadioActionTypes.GET_AD_RADIO_FAILURE, err);
